<template>
    <div class="home-view">
        <Topbar />
        <br>
        <br>
        <div class="container-img mt-2 small pb-3">
            <div class="col-md-6 m-auto mt-3 pb-2">
                <div class="card small">
                    <div class="card-header text-white pt-0 pb-0" :style="{ backgroundColor: moduloAtual().color }">
                        Outbound - Expedição
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1 text-left">

                        <div v-if="!this.idPreRomaneioReferencia">
                            <InputDefaultApp
                                :key="'preromaneio-' + idPreRomaneioReferencia"
                                inputPlaceHolderSufixo="Digite o pré romaneio"
                                titleScan="Escanear pré romaneio"
                                typeInputMode="numeric"
                                @displayScanFunction="buscarPreromaneio"
                                :enterKey="(e) => buscarPreromaneio(e.target.value)"
                                idInput="preromaneioInput"
                                :errorMessage="this.error"/>
                        </div>
                        
                        <div v-if="this.idPreRomaneioReferencia">
                            
                            <span class="font-weight-bold">Nº Pré Romaneio:</span>
                            <code class="ml-2">{{ this.pedidos[0].idPreRomaneioSaida }}</code>
                            <br>
                            <span class="font-weight-bold">Data:</span>
                            <code class="ml-2">{{ dateFormat(this.pedidos[0].dataAberturaPreRomaneioSaida) }}</code>
                            <br>
                            <span class="font-weight-bold">Usuário:</span>
                            <code class="ml-2">{{ this.pedidos[0].usuarioAberturaPreRomaneioSaida }}</code>
                            <br>
                            <span class="font-weight-bold">Transportadora:</span>
                            <code class="ml-2 bg-warning rounded p-1 text-dark font-weight-bold">{{ this.pedidos[0].transportadoraPreRomaneioSaida }}</code>
                            <br>
                            <br>
                            <InputDefaultApp
                                :key="'pedido-' + idPreRomaneioReferencia"
                                inputPlaceHolderSufixo="Digite o pedido"
                                titleScan="Escanear pedido"
                                typeInputMode="text"
                                @displayScanFunction="biparPedido"
                                :enterKey="(e) => biparPedido(e.target.value)"
                                idInput="barrasInput"
                                :errorMessage="this.errorBipagem"
                                :toUpperCase="true"/>

                            <button class="btn btn-sm btn-primary btn-block" data-toggle="modal" data-target="#modalAcoes">
                                Ações
                                <em class="fa fa-align-justify ml-2"></em>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 m-auto" v-if="this.idPreRomaneioReferencia">
                <div class="card small mt-1">
                    <div class="card-header text-white pt-1 pb-1 pl-1 pr-1 bg-secondary text-left">
                        <em class="fa fa-circle text-info mr-2"></em>
                        <span class="font-weight-bold small mr-2">Bipagem Pendente</span>
                        <em class="fa fa-circle text-warning mr-2"></em>
                        <span class="font-weight-bold small mr-2">Impressão Pendente </span>
                        <em class="fa fa-circle text-success mr-2"></em>
                        <span class="font-weight-bold small">Impresso</span>
                    </div>
                    <div class="card-body p-1 text-left small">
                        
                        <div class="scroll">
                            <table class="table table-bordered table-sm">
                                <thead class="bg-light">
                                    <tr>
                                        <th>CLIENTES</th>
                                        <th class="text-center">IMPRIMIR</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(cliente) in this.pedidos" :key="cliente.cliente.idCliente">
                                        <td>
                                            <span class="font-weight-bold text-danger">
                                                {{ cliente.cliente.nomeFantasia.toUpperCase() }} - {{ cliente.cliente.idCliente }}
                                            </span>
                                            <br>
                                            <span class="font-weight-bold" style="font-size: 10px;">TOTAL PENDENTE:</span>
                                            <span class="font-weight-bold pl-1 pr-1" style="margin-left: 10px; font-size: 13px;">
                                                [{{  cliente.totalPendente }}]
                                            </span>
                                            <br>
                                            <span class="font-weight-bold" style="font-size: 10px;">TOTAL BIPADO:</span>
                                            <span class="font-weight-bold pl-1 pr-1" style="margin-left: 26px; font-size: 13px;">
                                                [{{ cliente.totalBipado }}]
                                            </span>
                                        </td>
                                        <td class="text-center pt-3">
                                            <button :class="'btn btn-sm '+ cliente.color" @click="setClienteImprimir(cliente)">
                                                <em class="fa fa-print"></em>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="col-md-6 m-auto" v-if="this.multiplosBarra">
                <div class="card small mt-1">
                    <div class="card-header text-white pt-0 pb-0 pl-1 pr-1 bg-secondary text-center">
                        PEDIDOS MULTIPLOS
                    </div>
                    <div class="card-body p-1 text-left small">
                        <div class="container-fluid">
                            <div class="row mb-1"  v-for="(barras) in this.multiplosBarra" :key="barras.content">
                                <div class="col rounded font-weight-bold pt-1 pb-1" :style="'background-color :' + barras.color">
                                    <span>Cliente: </span>
                                    <span class="bg-light rounded pl-1 pr-1">{{ barras.cliente }}</span>
                                    <br>
                                    <span>Documento:</span>
                                    <span class="bg-light rounded pl-1 pr-1">{{ barras.documento }}</span>
                                    <br>
                                    <span>Pedido:</span> <span class="bg-light rounded pl-1 pr-1">{{ barras.pedido }}</span>
                                    <span class="ml-2 bg-light rounded pl-1 pr-1">{{ barras.volumesExpedido }} / {{ barras.totalVolume }}</span>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
            </div>

            <div class="mt-5 text-center text-secondary" v-if="!this.idPreRomaneioReferencia && !this.preRomaneios">
                <em class="fa fa-info-circle fa-3x mb-2"></em>
                <br>
                <span class="small">Bipe o pré romaneio para iniciar!</span>
            </div>
            <div class="col-md-6 m-auto" v-if="!this.idPreRomaneioReferencia && this.preRomaneios">

                <div class="card">
                    <div class="card-header pt-0 pb-0 small bg-success text-white">
                        <span>Pré-Romaneios Aguardando Expedição</span>
                    </div>
                    <div class="card-body p-1 table-scroll">
                        <table class="table table-striped table-bordered">
                            <caption class="d-none"></caption>
                            <thead class="d-none">
                                <tr>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody class="small">

                                <tr v-for="(item) in this.preRomaneios" :key="item.idpreromaneiossaida">
                                    <td class="text-left">
                                        
                                        <span class="text-primary font-weight-bold" @click="buscarPreromaneio(item.idpreromaneiossaida)">
                                            {{  item.idpreromaneiossaida }} {{ item.transportadora }}
                                        </span>
                                        <br>
                                        <span class="font-weight-bold small">
                                            <span class="d-flex" v-for="(cliente) in item.clientes.split(';')" :key="cliente">
                                                {{ cliente }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="text-right text-muted font-weight-bold small">
                                        PEDIDOS: {{ item.totalpedidos }}
                                        <br>
                                        VOLUMES: {{ parseInt(item.totalvolumes) }}
                                    </td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </div>
                </div>
                
            </div>
        </div>
        
        <LogoutModal />

        <Modal
            id="modalRetorno"
            title="Sucesso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-check-circle text-success fa-3x"></em>
                <br>
                <br>
                <span>{{ this.retornoMessage }}</span>
            </div>
        </Modal>

        <Modal
            id="modalImprimir"
            title="Pedidos"
            confirmText="Finalizar"
            cancelText="Fechar"
            :confirmFunction="showDialgoFinalizar"
            :cancelFunction="closeModal('modalImprimir')"
        >
            <div class="alert alert-warning p-1 small collapse text-dark" id="alert1">
                <ul class="small m-0 p-p">
                    <li class="small m-0">AO CLICAR NO BOTÃO FINALIZAR, STATUS MUDARA PARA EXPEDIDO. ESSE PROCESSO É IRREVERSÍVEL!</li>
                    <li class="small m-0">ANTES DE FINALIZAR, VERIFIQUE A LISTA ABAIXO SE CONTEM VOLUME PENDENTE!</li>
                    <li class="small m-0">O ENVIAR O PEDIDO PARA ANALISE DE EXPEDICAO, O PEDIDO SERA REMOVIDO DO PRE-ROMANEIO!</li>
                </ul>
            </div>
            <table class="talbe table-bordered table-sm text-left small w-100">
                <thead data-toggle="collapse" data-target="#alert1">
                    <tr>
                        <th class="text-center">
                            Regras de uso
                            <em class="fa fa-info-circle text-warning pull-right"></em>
                        </th>
                    </tr>
                </thead>
                <tbody class="small">
                    <tr v-for="(item) in this.clienteImprimir.outboundVolumes" :key="item.produto.idDocumentos"
                    :class="parseInt(item.volumeexpedido) === parseInt(item.totalVolume) ? 'bg-success text-white' : 'bg-danger text-white'">
                        <td>

                            <div class="form-row">
                                <div class="col-9">
                                    <span>
                                        <span class="text-danger bg-light rounded font-weight-bold pl-1 pr-1 mr-2">
                                            {{ item.pedido.numeroPedido }}
                                        </span>
                                        ({{ parseInt(item.volumeexpedido) }} / {{ parseInt(item.totalVolume) }}) 
                                        <br>
                                        DOCUMENTO: <span class="bg-light text-dark font-weight-bold rounded pl-1 pr-1">
                                            {{ item.produto.idDocumentos }}
                                        </span>
                                         
                                    </span>

                                    <div class="mt-2">
                                        N° ROMANEIO:
                                        <span class="text-dark bg-light rounded pl-1 pr-1 font-weight-bold">
                                            {{ item.idRomaneioSaida > 0 ?  item.idRomaneioSaida : "Não Tem" }}
                                        </span>
                                    </div>
                                    
                                </div>
                                <div class="col-3 text-center pt-2 border-left">
                                    <button class="btn btn-secondary btn-sm" style="font-size: 9px;" v-if="item.pedido.statusAtual !== 'EXPEDIDO'" @click="dialogoEnviarPedidoParaAnalise(item)">
                                        Análise
                                        <em class="fa fa-paper-plane"></em>
                                    </button>
                                    <span style="font-size: 8px;" v-if="item.pedido.statusAtual === 'EXPEDIDO'">
                                        <em class="fa fa-check-circle fa-3x mt-2"></em>
                                    </span> 
                                </div>
                            </div>             
                        </td>
                    </tr>
                </tbody>
            </table>
        </Modal>
        <Modal
            id="modalConfirmarAnalise"
            title="Confirme:"
            confirmText="Sim"
            cancelText="Não"
            :confirmFunction="enviarPedidoParaAnalise"
            :cancelFunction="closeModal('modalConfirmarAnalise')"
        >
            <div class="text-left">
                Deseja enviar o pedido <br>
                N°
                <span class="bg-light rounded border pl-1 pr-1 text-danger font-weight-bold">
                    {{ this.pedidoEnviarParaAnalise.pedido.numeroPedido }}
                </span>
                <br>
                para análise?
            </div>
        </Modal>
        <Modal
            id="modalDialogoFinalizar"
            title="Confirme:"
            confirmText="Sim"
            cancelText="Não"
            :confirmFunction="finalizar"
            :cancelFunction="closeModal('modalDialogoFinalizar')"
        >
            Deseja finalizar os pedidos?
        </Modal>

        <Modal
            id="modalConfirmarAssinatura"
            title="Confirme:"
            confirmText="Sim"
            cancelText="Não"
            :confirmFunction="modalBuscarMotorista"
            :cancelFunction="() => cancelarAssinatura('modalConfirmarAssinatura')"
        >
            <div class="text-left">
                Deseja assinar o romaneio <br>
                N°
                <span class="bg-light rounded border pl-1 pr-1 text-danger font-weight-bold">
                    {{ this.idRomaneioSaida }}
                </span>
            </div>
        </Modal>

        <Modal
            id="modalAssinarRomaneioDigital"
            title="Assinatura:"
            :buttonList="[]"
            :noFooter="true"
            :cancelFunction="() => cancelarAssinatura('modalAssinarRomaneioDigital')"
        >
             <button class="btn btn-sm w-100 btn-warning text-white" @click="() => this.modalBuscarMotorista()">
                Alterar Motorista
                <em class="fa fa-undo ml-2"></em>
            </button>
            <div class="row text-left mt-2">
                <div class="col-12 mb-3 border-bottom border-top">
                    <code>Motorista:</code>
                    <span class="ml-2">{{ this.motorista.nome }}</span>
                    <br>
                    <code>Placa:</code>
                    <span class="ml-2">{{ this.motorista.placa }}</span>
                </div>
            </div>
            <span>Assine abaixo: <em class="fa fa-pen ml-2"></em></span>
            <div class="text-left border-bottom border-2 mb-2">
                <SignaturePad
                    :width="265"
                    :height="100"
                    @update:signature="handleSignature"
                />
            </div>
        </Modal>

        <Modal
            id="modalDialogoFinalizar"
            title="Confirme:"
            confirmText="Sim"
            cancelText="Não"
            :confirmFunction="finalizar"
            :cancelFunction="closeModal('modalDialogoFinalizar')"
        >
            Deseja finalizar os pedidos?
        </Modal>

        <Modal
            id="modalBuscarMotorista"
            title="Identificação Motorista"
            confirmText="Buscar"
            cancelText="Não"
            :confirmFunction="buscarMotorista"
            :cancelFunction="() => cancelarAssinatura('modalBuscarMotorista')"
        >
            <div class="alert alert-warning pt-1 pb-1" v-if="this.errorBuscarMotorista">
                <em class="fa fa-info-circle mr-2"></em>
                {{ this.errorBuscarMotorista }}
            </div>
            <input
            class="form-control form-control-sm"
            id="rgMotoristaInput"
            placeholder="Informe o RG do motorista"
            autofocus="on"
            @keypress.enter="buscarMotorista"
            autocomplete="off"
            >
        </Modal>

        <Modal
            id="modalAcoes"
            title="Ações"
            :buttonList="[]"
            :noFooter="true"
            :cancelFunction="focusBarras"
        >
            <button class="btn btn-info btn-sm btn-block m-1" @click="novaExpedicao">
                Expedir novo pré-romaneio
                <em class="fa fa-undo ml-2"></em>
           </button>
           <button class="btn btn-danger btn-sm btn-block m-1" @click="closeModal('modalAcoes')">
                Sair
                <em class="fa fa-times ml-2"></em>
           </button>
        </Modal>

        <Modal
            id="modalError"
            title="Aviso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalError')"
            cancelText="OK"
            :customClass="this.classModal"
        >
            <div class="small text-center">
                <em class="fa fa-info-circle text-warning fa-3x"></em>
                <br>
                <br>
                <span>{{ this.errorMessageModal }}</span>
            </div>
        </Modal>
    </div>
</template>
  
  
<script>
// @ is an alias to /src
import Topbar from '@/components/Topbar.vue'
import LogoutModal from '@/components/LogoutModal.vue'
import ViewMixin from './ViewMixin'
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
import api, { getUserId } from '../services/api'
import $ from "jquery";
import audioService from '@/services/audioService.js';
import InputDefaultApp from '../components/InputDefaultApp.vue';
import { dateFormat } from '../utils';
import Modal from "../components/Modal.vue";
import SignaturePad from '../components/SignaturePad.vue';

export default {
    name: 'Expedicao',
    mixins: [
        ViewMixin
    ],
    components: {
        Topbar,
        LogoutModal,
        InputDefaultApp,
        Modal,
        SignaturePad
    },

    data: () => {
        return {
            error: null,
            retornoMessage: null,
            preRomaneios: null,
            pedidos: null,
            multiplosBarra: null,
            errorBipagem: null,
            idPreRomaneioReferencia: null,
            transportadoraPreRomaneioSaida: null,
            clienteImprimir: {
                outboundVolumes: []
            },
            pedidoEnviarParaAnalise: {
                pedido: {
                    numeroPedido: null
                }
            },
            errorMessageModal: null,
            classModal: null,
            idRomaneioSaida: null,
            motorista: {
                nome: null,
                placa: null
            },
            errorBuscarMotorista: null,
            signature: null,
        };
    },

    async mounted() {
        try {
            await this.validarToken();
        } catch (e) {
            if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }

        this.getPreRomaneios();
    },

    methods: {
        getUserId,
        dateFormat,

        handleSignature(base64) {
            this.signature = base64;
            this.assinarRomaneioDigital();
        },

        showErrorModal(message) {
            this.errorMessageModal = message;
            $("#modalError").modal('show');
        },

        showMessageSuccess(message) {
            this.retornoMessage = message;
            $("#modalRetorno").modal('show');
        },

        playSoundWarning() {
            audioService.playAlarm();
        },

        playSoundSuccess() {
            audioService.success();
        },

        alertaSonoro(message) {
            this.classModal = "bg-danger";
            this.showErrorModal(message);
            audioService.ban();
        },

        async validarToken() {
            this.carregando = true;
    
            await api.get("/validar-token");
    
            this.carregando = false;
        },

        closeModal(modal) {
            $("#" + modal).modal("hide");
        },

        focusBarras() {
            $("#barrasInput").val("");
            $("#barrasInput").focus();
        },

        async getPreRomaneios() {
            try {
                let response = await api.get("/outbound/expedicao/preromaneios");
  
                let arr = response.data.preromaneios;
                this.preRomaneios = arr.length > 0 ? arr : null;

                setTimeout(() => {
                    $("#preromaneioInput").focus();
                }, 250);
            } catch (error) {
                this.showErrorModal(error.message);
            }
        },

        novaExpedicao() {
            this.idPreRomaneioReferencia = null;
            this.transportadoraPreRomaneioSaida = null;
           
            $("#barrasInput").val("");
            $("#preromaneioInput").val("");
            $("#rgMotoristaInput").val("");

            setTimeout(() => {
                $("#preromaneioInput").focus();
            }, 250);
            
            this.pedidos = null;
            this.closeModal("modalAcoes");
            this.error = null;
            this.errorBipagem = null;
            this.multiplosBarra = null;
        },

        async buscarPreromaneio(id) {
            this.carregando = true;
            this.error = null;
            this.multiplosBarra = [];

            try {
                let body = {
                    idPreRomaneio: id,
                    idUsuario: getUserId()
                };

                let retorno = await api.post("/outbound/expedicao/listapedidos", body);
                
                this.idPreRomaneioReferencia = retorno.data[0].idPreRomaneioSaida;
                this.transportadoraPreRomaneioSaida = retorno.data[0].transportadoraPreRomaneioSaida;

                let totalInpressos = 0;

                for (let item of retorno.data) {
                    let totalBipado = 0;
                    let totalPendente = 0;

                    for (const outbound of item.outboundVolumes) {

                        this.showMultiploBarras(item.cliente, outbound);

                        totalBipado += outbound.volumeexpedido;
                        totalPendente += outbound.totalVolume - outbound.volumeexpedido;
                        totalInpressos += item.idRomaneioSaida > 0 ? 1 : 0;
                    }

                    item["totalBipado"] = totalBipado;
                    item["totalPendente"] = totalPendente;
                    item["color"] = totalPendente === 0 ? "btn-warning" : "btn-info";
                    
                    if (totalPendente === 0 && totalInpressos > 0) {
                       item["color"] = "btn-success";
                    }
                }

                this.pedidos = retorno.data;

                setTimeout(() => {
                    
                    $("#barrasInput").focus();
                }, 250);
                
                this.carregando = false;
            } catch (error) {
                this.carregando = false;
                this.playSoundWarning();
                this.error = error.message;
                $("#preromaneioInput").focus();
                $("#preromaneioInput").select();
            } 
        },

        showMultiploBarras(cliente, pedido) {

            if (pedido.totalVolume >= 2) {

                let color = "#F7DC6F";

                if (parseInt(pedido.volumeexpedido) === parseInt(pedido.totalVolume)) {
                    color = '#7DCEA0';
                } else if (pedido.volumeexpedido === 0) {
                    color = '#EC7063';
                }

                let barras = {
                    color: color,
                    cliente: cliente.nomeFantasia,
                    documento: pedido.produto.idDocumentos,
                    pedido: pedido.pedido.numeroPedido,
                    volumesExpedido: parseInt(pedido.volumeexpedido),
                    totalVolume: parseInt(pedido.totalVolume)
                };

                this.multiplosBarra.push(barras);
            }
        },

        pegaJson(codigo) {

            if (codigo.includes("{\"sorte_code\":\"")) {
                let obj = JSON.parse(codigo);
                return obj.sorte_code;
            }

            let indexOfVirgula = codigo.indexOf(',');
            let trecho = codigo.substr(0, indexOfVirgula);

            let indexOfAspasFinais = trecho.length - 1;
            let aspasFinais = trecho[indexOfAspasFinais];

            let aspasIniciais = -1;
            for(let i = 0; i < trecho.length - 1; i++){
                if(trecho[i] == aspasFinais){
                    aspasIniciais = i;
                }
            }
            
            let numero = trecho.substring(aspasIniciais + 1, indexOfAspasFinais)
            return numero.replace("/", "-");
        },

        async biparPedido(pedido) {
            
            this.errorBipagem = null;

            if (pedido.trim() === "") {
                this.errorBipagem = "Bipe o código de barras do pedido!";
                this.playSoundWarning();
                $("#barrasInput").focus();
                $("#barrasInput").select();
                return;
            }

            let codigobarras = String(pedido).replace('=', '').toLowerCase();
            if(codigobarras.includes("sender") || codigobarras.includes("id") || codigobarras.includes("security")){
                codigobarras = this.pegaJson(codigobarras);
            }

            if (codigobarras.trim() === "") {
                codigobarras = pedido.trim();
            }

            this.carregando = true;
            try {
                this.carregando = false;

                let body = {
                    idUsuario: getUserId(),
                    idPreRomaneio: this.idPreRomaneioReferencia,
                    codigobarras: codigobarras
                };

                let retorno = await api.post("/outbound/expedicao/addconferencia", body);

                if (JSON.stringify(retorno).includes("mensagem")) {
                    this.carregando = false;
                    this.classModal = null;
                    this.playSoundWarning();
                    this.errorBipagem = retorno.data[0].mensagem;
                    $("#barrasInput").focus();
                    $("#barrasInput").select();

                    return;
                }

                this.updateBipagem(retorno);
                this.updateMultiplosBarra();
            } catch (error) {
                if (error.message.includes("alertaSonoro")) {
                    let errorObj = JSON.parse(error.message);
                    this.alertaSonoro(errorObj.alertaSonoro);
                } else {
                    this.classModal = null;
                    this.carregando = false;
                    this.classModal = null;
                    this.playSoundWarning();
                    this.errorBipagem = error.message;
                    $("#barrasInput").focus();
                    $("#barrasInput").select();
                }
            }
        },

        updateBipagem(retorno) {
            let totalInpressos = 0;

            for (let item of this.pedidos) {
                totalInpressos += item.idRomaneioSaida > 0 ? 1 : 0;
                

                if (item.cliente.idCliente === retorno.data[0].idCliente) {
                    item["totalBipado"] = item.totalBipado+1;
                    item["totalPendente"] = item.totalPendente-1;
                    item["color"] = item.totalPendente === 0 ? "btn-warning" : "btn-info";
                    
                    this.updateVolume(retorno.data[0], item);
                    
                    if (item.totalPendente === 0) {
                        this.playSoundSuccess();

                        if (totalInpressos > 0) {
                            item["color"] = "btn-success";
                        }
                    }
                }
            }

            $("#barrasInput").focus();
            $("#barrasInput").select();
        },

        updateVolume(pedidoRetorno, pedidoFront) {

            for (let item of pedidoFront.outboundVolumes) {
                if (item.produto.idDocumentos === pedidoRetorno.idDocumentos) {
                    item["volumeexpedido"] = item.volumeexpedido +1;
                }
            }
        },

        updateMultiplosBarra() {

            this.multiplosBarra = [];

            let i = 0;
            for (let pedido of this.pedidos) {
                for (let outbound of pedido.outboundVolumes) {
                      
                    if (outbound.totalVolume >= 2) {

                        let color = "#F7DC6F";

                        if (parseInt(outbound.volumeexpedido) === parseInt(outbound.totalVolume)) {
                            color = '#7DCEA0';
                        } else if (outbound.volumeexpedido === 0) {
                            color = '#EC7063';
                        }

                        let barras = {
                            color: color,
                            cliente: this.pedidos[i].cliente.nomeFantasia,
                            documento: outbound.produto.idDocumentos,
                            pedido: outbound.pedido.numeroPedido,
                            volumesExpedido: parseInt(outbound.volumeexpedido),
                            totalVolume: parseInt(outbound.totalVolume)
                        };

                        this.multiplosBarra.push(barras);
                    }
                }

                i++;
            }
        },

        setClienteImprimir(cliente) {
            this.clienteImprimir = cliente;
            $("#modalImprimir").modal("show");
        },

        showDialgoFinalizar() {
            this.closeModal("modalImprimir");

            let pedidosPendentes = 0;
            let pedidosImpressos = 0;
            for (const item of this.clienteImprimir.outboundVolumes) {
                if (item.volumeexpedido != item.totalVolume) {
                    pedidosPendentes++;
                }

                if (item.idRomaneioSaida > 0) {
                    pedidosImpressos++;
                }
            }

            if (pedidosImpressos === this.clienteImprimir.outboundVolumes.length) {
                this.showErrorModal("Não há mais pedidos pendentes!");
                return;
            }

            if (pedidosPendentes === this.clienteImprimir.outboundVolumes.length - pedidosImpressos) {
                this.showErrorModal("Não é possível finalizar os pedidos, pois não há pedidos para concluir!");
                return;
            }

            $("#modalDialogoFinalizar").modal("show");
        },

        async finalizar() {
            this.closeModal("modalDialogoFinalizar");
            this.carregando = true;
            try {

                let body = {
                    idCliente: this.clienteImprimir.cliente.idCliente,
                    transportadora: this.clienteImprimir.transportadoraPreRomaneioSaida,
                    idUsuario: getUserId(),
                    idPreRomaneio:  this.clienteImprimir.idPreRomaneioSaida
                };

                let retorno = await api.post("/outbound/expedicao/imprimir", body);

                if (JSON.stringify(retorno.data).includes("idRomaneioSaida")) {
                    let romaneio = retorno.data[0].idRomaneioSaida;
                    let pedidosExpedidos = retorno.data[0].listaPedido;
                    
                    for (let item of this.pedidos) {
                        if (item.cliente.idCliente === this.clienteImprimir.cliente.idCliente) {
                            item["color"] = "btn-success";

                            this.updatePedido(pedidosExpedidos, romaneio, item);
                            break;
                        }
                    }
                    this.enviarRomaneioParaFilaDeImpresao(romaneio);
                }

                this.carregando = false;
            } catch (error) {
                this.carregando = false;
                this.classModal = null;
                this.playSoundWarning();
                this.showErrorModal(error.message);
            }
        },

        updatePedido(listaPedidosRetorno, romaneio, pedidoFront) {

            for (let pedidoRetorno of listaPedidosRetorno) {

                for (let item of pedidoFront.outboundVolumes) {

                    if (item.pedido.numeroPedido === pedidoRetorno.numeroPedido) {
                        item.pedido["statusAtual"] = "EXPEDIDO";
                        item["idRomaneioSaida"] = romaneio;
                    }
                }
            }
        },

        cancelarAssinatura(modal) {
            $("#rgMotoristaInput").val("");
            this.closeModal(modal);
            this.showMessageSuccess("Expedição finalizada com sucesso!");
            this.getPreRomaneios();
        },

        enviarRomaneioParaFilaDeImpresao(romaneio) {
            this.idRomaneioSaida = romaneio;
            $("#modalConfirmarAssinatura").modal("show");
        },

        modalBuscarMotorista() {
            this.closeModal("modalConfirmarAssinatura");
            this.closeModal("modalAssinarRomaneioDigital");
            $("#modalBuscarMotorista").modal("show");
            setTimeout(() => {
                $("#rgMotoristaInput").focus();
            }, 500);
        },

        async buscarMotorista() {
            let rg = $("#rgMotoristaInput").val();
            this.closeModal("modalBuscarMotorista");

            try {
                let response = await api.post('/outbound/motorista/rg', { rg: rg });
                this.motorista = response.data;

                if (this.transportadoraPreRomaneioSaida !== this.motorista.transportadora) {
                    this.errorBuscarMotorista = "Motorista não pertence a esta transportadora!";
                    
                    setTimeout(() => {
                        this.modalBuscarMotorista();
                    }, 500);

                    this.playSoundWarning();

                    return;
                }
                $("#rgMotoristaInput").val("");
                this.modalAssinarRomaneioDigital();
            } catch (error) {
                this.errorBuscarMotorista = error.message;
                setTimeout(() => {
                    this.modalBuscarMotorista();
                }, 500);
                this.playSoundWarning();
            }
        },

        modalAssinarRomaneioDigital() {
            this.closeModal("modalConfirmarAssinatura");
            $("#modalAssinarRomaneioDigital").modal("show");
        },

        async assinarRomaneioDigital() {
            this.closeModal("modalAssinarRomaneioDigital");
            try {
                let response1 = await api.post("/outbound/romaneiodigital/vincular", {
                    idMotorista: this.motorista.idmotorista,
                    idTransportadora: this.motorista.idtransp,
                    idRomaneio: this.idRomaneioSaida,
                    placa: this.motorista.placa
                });


                if (JSON.stringify(response1).includes('success')) {
                    let response2 = await api.post("/outbound/romaneiodigital/getvinculo", {
                        idRomaneio: this.idRomaneioSaida
                    });

                    if (JSON.stringify(response2).includes('idVinculo')) {
                        let response3 = await api.post("/outbound/romaneiodigital/fechar", {
                            idRomaneioDigital: response2.data.idVinculo,
                            assinatura: this.signature
                        });

                        if (JSON.stringify(response3).includes('success')) {
                            this.showMessageSuccess(`Romaneio N° ${this.idRomaneioSaida} assinado com sucesso!`);
                            $("#rgMotoristaInput").val("");
                        }
                    }
                }
            } catch (error) {
                this.errorBipagem = error.message;
                this.playSoundWarning();
            }
        },

        dialogoEnviarPedidoParaAnalise(pedido) {
            this.pedidoEnviarParaAnalise = pedido;
            this.closeModal("modalImprimir");

            $("#modalConfirmarAnalise").modal("show");
        },

        async enviarPedidoParaAnalise() {
            this.carregando = false;
            this.closeModal("modalConfirmarAnalise");
            
            try {

                let body = {
                    idDocumento: this.pedidoEnviarParaAnalise.produto.idDocumentos,
                    idUsuario: getUserId()
                };

                let retorno = await api.post("/outbound/expedicao/enviarparaanalise", body);

                if (JSON.stringify(retorno.data).includes("success")) {

                    for (let item of this.pedidos) {

                        let newListPedidos = [];

                        for (let pedidoAux of item.outboundVolumes) { 
                            if (pedidoAux.produto.idDocumentos !== this.pedidoEnviarParaAnalise.produto.idDocumentos) {
                                newListPedidos.push(pedidoAux);
                            }
                        }

                        item["outboundVolumes"] = newListPedidos;
                        item["totalBipado"] = item.totalBipado-1;
                    }

                    this.showMessageSuccess(`Pedido n° ${this.pedidoEnviarParaAnalise.pedido.numeroPedido} enviado para análise com sucesso!`);
                }
                this.carregando = false;
            } catch (error) {
                this.carregando = false;
                this.playSoundWarning();
                this.classModal = null;
                this.showErrorModal(error.message);
            }
        },
    }
}
</script>
  
<style scoped lang="scss">
    .home-view {
        height: 100%;
    }

    .scroll {
        height: 140px;
        overflow-y: auto;
        overflow-x: hidden;
        width: 100%;
    }

    .table-scroll {
        height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
        width: 100%;
    }
</style>
  